import './FixedMgeList.scss'

import React from 'react'
import Tooltip from '../../core/Tooltip/Tooltip'
import Input from '../../forms/Input/Input'
import ReasonIcon from '../ReasonIcon/ReasonIcon'
import { useEffect, useState } from 'react'
import { useCharacters } from '../../../contexts/Characters'
import { capitalize } from '../../../utilities/helpers'
import { Roles, medalsGroups } from '../../../utilities/constants'
import { Link, useNavigate } from 'react-router'
import Dropdown from '../../core/Dropdown/Dropdown'
import koalition from '../../../api/koalition'

const FixedMgeList = ({ editable, targetsForm, participants, setParticipants, targets, setTargets }) => {
    const characters = useCharacters()
    const navigate = useNavigate()
    const [dragging, setDragging] = useState(false)
    const [participantsGroups, setParticipantsGroups] = useState([])
    const characterActions = (character) => [
        { name: 'navigate', label: 'Show character', onClick: () => navigate(`/characters/${character._id}`) },
        { name: 'boost', label: 'Toggle boost', onClick: () => toggleProperty('boost', character) },
        { name: 'debuff', label: 'Toggle debuff', onClick: () => toggleProperty('debuff', character) },
        { name: 'received', label: 'Add received', onClick: () => addReceived(character) },
        { name: 'partialReceived', label: 'Toggle partial received', onClick: () => toggleProperty('partialReceived', character) },
        { name: 'ineligible', label: 'Toggle ineligible', onClick: () => toggleProperty('ineligible', character) },
    ]

    const toggleProperty = (property, character) => {
        koalition.put(`/characters/${character._id}`, { mge: { ...character.mge, [property]: !character.mge[property] } }).then((response) => {
            toaster.success(`Character updated successfully`)
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
        })
    }

    const addReceived = (character) => {
        console.log(character.seasonalRecords)
        const updatedRecord = character.seasonalRecords.find((record) => record.current)
        updatedRecord.receivedFixedMges++

        koalition.put(`characters/${character._id}`, { seasonalRecords: character.seasonalRecords }).then((response) => {
            toaster.success('Seasonal record updated successfully')
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
        })
    }

    const onParticipantDragStart = (event, participant) => {
        console.log('start')
        event.stopPropagation()
        setDragging(participant)
    }
    
    const onParticipantDragEnd = () => {
        console.log('end')
        setDragging(false)
    }

    const onDropPointDragOver = (event) => {
        event.preventDefault()
        event.target.classList.add('dragover')
    }

    const onDropPointDragLeave = (event) => {
        event.target.classList.remove('dragover')
    }

    const onDropPointDrop = (event, group, groupPosition) => {
        event.preventDefault()
        const sourceIndex = participants.findIndex((participant) => participant._id === dragging._id)
        let targetIndex = group.from - 1 + groupPosition
        if (sourceIndex < targetIndex) targetIndex--
        let updatedParticipants = participants.filter((participant) => participant._id !== dragging._id)
        updatedParticipants.splice(targetIndex, 0, dragging)
        setParticipants(updatedParticipants)
    }

    useEffect(() => {
        setParticipantsGroups(medalsGroups.map((group) => {
            const groupParticipants = participants.slice(group.from - 1, group.to)
            const groupClassName = group.from <= 5 && 'col-xl' || group.from <= 8 && 'col-lg-6' || 'col-12'
            return { ...group, participants: groupParticipants, className: groupClassName }
        }))
    }, [participants])

    return (
        <ul className={`fixed-mge-list row ${dragging ? 'dragging' : ''}`}>
            {participantsGroups.map((group, groupIndex) => (
                <React.Fragment key={group.medals}>
                    {groupIndex === 5 && <li className="col-12"></li>}
                    <li className={`${group.className} mb-4`}>
                        <div className={`card group h-100 px-4 pt-4 pb-3`}>
                            <header className="row flex-nowrap justify-content-center align-items-center">
                                <div className="col-auto">
                                    {group.to !== group.from && <span>Group </span>}
                                    <span>{group.from}</span>
                                    {group.to !== group.from && <span> - {group.to}</span>}
                                </div>

                                <div className="col-auto ml-auto">
                                    <span className="flex-center-y">
                                        <span>{group.medals}</span>
                                        <span className="medal-icon">
                                            <img src="/images/icons/medal.svg" />
                                        </span>
                                    </span>
                                </div>
                            </header>

                            <main className="mt-4">
                                <ul className="row justify-content-center px-3">
                                    {group.participants.map((character, index) => (
                                        <li className="col-auto d-flex mb-3 px-0" key={character._id}>
                                            {characters.authorized([Roles.developer, Roles.admin]) && (
                                                <div className="drop-point" onDragOver={onDropPointDragOver} onDragLeave={onDropPointDragLeave} onDrop={(event) => onDropPointDrop(event, group, index)}></div>
                                            )}
                                            <Dropdown items={characterActions(character)} rightClick={true} variant="content">
                                                <span className="chip primary participant flex-center-y" draggable={editable} onDragStart={(event) => onParticipantDragStart(event, character)} onDragEnd={onParticipantDragEnd}>
                                                    {characters.authorized([Roles.developer, Roles.admin]) && (character.reason || character.mge?.reason) && (
                                                        <span className="mr-3">
                                                            <ReasonIcon reason={character.reason || character.mge?.reason} partialReceived={character.mge?.partialReceived} />
                                                        </span>
                                                    )}
                                                    <span className="name unselectable">{character.name}</span>
                                                </span>
                                            </Dropdown>
                                        </li>
                                    ))}
                                    {characters.authorized([Roles.developer, Roles.admin]) && (
                                        <li className="col-auto d-flex mb-3 px-0">
                                            <div className="drop-point" onDragOver={onDropPointDragOver} onDragLeave={onDropPointDragLeave} onDrop={(event) => onDropPointDrop(event, group, group.participants.length)}></div>
                                        </li>
                                    )}
                                </ul>
                            </main>

                            <footer className="targets">
                                {editable ? (
                                    <div className="row align-items-center">
                                        <div className="col-auto points-target pr-0">
                                            <Input type="number" control={targetsForm.$state.controls[group.medals].controls.from} />
                                        </div>
                                        <div className="col"><hr /></div>
                                        <div className="col-auto points-target pl-0">
                                            <Input type="number" control={targetsForm.$state.controls[group.medals].controls.to} />
                                        </div>
                                    </div>
                                ) : (
                                    <span>Points between {targets[group.medals].from}M and {targets[group.medals].to}M</span>
                                )}
                            </footer>
                        </div>
                    </li>
                </React.Fragment>
            ))}
        </ul>
    )
}

export default FixedMgeList